import React from 'react';
import { formatCompanyFallbackId, formatCompanyInlineLabel } from '../../lib/licenseHelper';

// IMP-166: "회사명(메인) + 보조 ID" 동시 표시 패턴 공용 컴포넌트.
//
// PR #220 머지 후에도 동일 패턴이 5곳(AllocationHistoryTable / CustomerLicensesTable /
// LicenseSubsidiaryTab / LicenseDealerTab 사이드패널 / AllocateDealerModal)에 중복 존재.
// 향후 디자인 변경(툴팁, copy 버튼 등) 시 단일 지점 수정으로 일원화.
//
// variant:
//   - 'default' : <div>{name||id}</div> + (name 일 때) <small.text-muted>{id}</small>
//   - 'sidebar' : 이름 fw-semibold + small (active 시 text-white-50, 비활성 text-muted),
//                 보조 라인에 id · orgLabel 합성 (LicenseDealerTab 사이드패널)
//
// 인라인 "name (id)" 케이스는 input value(string) 가 필요한 AllocateDealerModal 1곳뿐이라
// 컴포넌트 분기 대신 formatCompanyInlineLabel 헬퍼로만 제공한다(string SSoT).

// 인라인 라벨 포맷 — string 이 필요한 호출부(예: <input value>)에서 사용.
// IMP-424: 정의는 licenseHelper.js 로 이전(licenseHelper 내부 재사용 시 순환 의존 회피).
// 기존 소비처(AllocateDealerModal 등)의 import 경로 호환을 위해 그대로 re-export.
export { formatCompanyInlineLabel };

const CompanyCell = ({
    id,
    companyMap = {},
    fallback = '-',
    // active / orgLabel 은 variant='sidebar' 전용 — 'default' 에서는 무시된다.
    variant = 'default',
    active = false,
    orgLabel = null,
}) => {
    const company = id ? companyMap[id] : null;
    const name = company?.name || null;

    if (!id) return <>{fallback}</>;

    // IMP-168: 매칭 실패(name 부재) 시 raw 식별자 노출 방어 — 비표준 형식은 truncate.
    // 매칭 성공 시 보조 small 에 표시되는 id 는 표준 dealerId 이므로 raw 유지.
    const fallbackId = formatCompanyFallbackId(id);

    if (variant === 'sidebar') {
        return (
            <>
                <div className="fw-semibold">{name || fallbackId}</div>
                <small className={active ? 'text-white-50' : 'text-muted'}>
                    {name ? id : null}
                    {name && orgLabel ? ' · ' : null}
                    {orgLabel}
                </small>
            </>
        );
    }

    // default
    return (
        <>
            <div>{name || fallbackId}</div>
            {name && <small className="text-muted">{id}</small>}
        </>
    );
};

export default CompanyCell;
